import { combineReducers } from 'redux';
import Project from 'components/project/reducers/project_reducer';
import Tasks from './tasks';
import connectableObjects from './connectable_objects';
import Deals from './deals';
import Docs from './docs';
import Leads from './leads';
import Contacts from './contacts';
import Ui from './ui';
import EmailModal from './email_modal';
import TaskModal from 'components/project/reducers/task_modal';
import LeadModal from './lead_modal';
import SelectedLeads from './selected_leads';
import Alert from './alerts';
import PageFlags from './page_flags';
import ShadowGridTab from './shadow_grid_tab';
import Session from './session';
import VisualMedia from './visual_media';
import EdgeCrm from './edge_crm';
import ActionIndicators from './action_indicators';

const nullReducer = state => ({ ...state });

const rootReducer = combineReducers({
  actionIndicators: ActionIndicators,
  alert: Alert,
  airbrake: nullReducer,
  apexDealStagesConfig: nullReducer,
  connectableObjects: connectableObjects,
  contacts: Contacts,
  currentUser: nullReducer,
  docs: Docs,
  edgeCrm: EdgeCrm,
  features: nullReducer,
  project: Project,
  tasks: Tasks,
  leads: Leads,
  leadShow: nullReducer,
  ui: Ui,
  emailModal: EmailModal,
  taskModal: TaskModal,
  LeadModal: LeadModal,
  selectedLeads: SelectedLeads,
  contactRoles: state => state || [],
  availableDatabaseOptions: state => state || [],
  pageFlags: PageFlags,
  leadsOptions: nullReducer,
  propertyComps: nullReducer,
  shadowGridOptions: nullReducer,
  shadowGridTab: ShadowGridTab,
  session: Session,
  taskOptions: nullReducer,
  visualMediaData: VisualMedia,
  deals: Deals,
  dealsTab: state => state || {},
  vouchersTab: state => state || {},
});

export default rootReducer;
